
import { third_party_constants } from "constants/third_party_constants";

export const meetings = [
    {
        key: 0,
        title: "Meeting 1",
        time: {
            start: "10:00 AM",
            end: "11:00 AM",
        },
        source: third_party_constants.zoom,
        link: "https://zoom.us/j/1234567890",
        participants: [
            {
                name: "Tim Tregubov",
                image: "assets/images/tim.jpeg",
            },
            {
                name: "Natalie Svoboda",
                image: "assets/images/natalie.jpeg",
            },
        ],
    },
    {
        key: 1,
        title: "Meeting 2",
        time: {
            start: "11:00 AM",
            end: "12:00 PM",
        },
        source: third_party_constants.google_meet,
        link: "https://meet.google.com/123-456-789",
        participants: [
            {
                name: "Tim Tregubov",
                image: "assets/images/tim.jpeg",
            },
            {
                name: "Natalie Svoboda",
                image: "assets/images/natalie.jpeg",
            },
        ],
    },
    {
        key: 2,
        title: "Meeting 3",
        time: {
            start: "12:00 PM",
            end: "1:00 PM",
        },
        source: third_party_constants.microsoft_teams,
        link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_MjMzZjY0ZjQtZjQ2ZS00ZjQ2LWI2ZjAtZjQyZjQyZjQyZjQy%40thread.v2/0?context=%7b%22Tid%22%3a%22b9b9b9b9-b9b9-b9b9-b9b9-b9b9b9b9b9b9%22%2c%22Oid%22%3a%22a9a9a9a9-a9a9-a9a9-a9a9-a9a9a9a9a9a9%22%7d",
        participants: [
            {
                name: "Tim Tregubov",
                image: "assets/images/tim.jpeg",
            },
            {
                name: "Natalie Svoboda",
                image: "assets/images/natalie.jpeg",
            },
            {
                name: "Bob Smith",
                //image: "assets/images/bob.jpeg",
            },
            {
                name: "John Doe",
                //image: "assets/images/john.jpeg",
            }
        ],
    },
];

export const recentPeopleGroups = [
    {
        key: 0,
        name: "Tim Tregubov",
        username: "timtregubov",
        image: "assets/images/tim.jpeg",
        lastMeetingName: "Sprint 1 Check-in",
        actionItems: [
            {
                brief: "Send follow up email to Bob",
                body: "Follow up with Tim about the meeting",
            },
            {
                brief: "Send follow up email to Bob",
                body: "Follow up with Tim about the meeting",
            },
        ],
        relations: [
            "CS - 98",
            "Meetings Aggregator",
        ],
    },
    {
        key: 1,
        name: "Natalie Svoboda",
        username: "nataliesvoboda",
        image: "assets/images/natalie.jpeg",
        lastMeetingName: "UI Design Mockup",
        actionItems: [],
        relations: [
            "CS - 98",
            "Meetings Aggregator",
        ],
    }
];

export const emails = [
    "user0@7jzzes.com",
    "user1@zzm6fh.com",
    "user2@axu2kf.com",
    "user3@7vts45.com",
    "user4@z4se4m.com",
    "user5@tm1aym.com",
    "user6@agq3tj.com",
    "user7@paj0wj.com",
    "user8@bkg8r1.com",
    "user9@24ilhr.com",
    "user10@ovwwvz.com",
    "user11@26chx8.com",
    "user12@2lv7ry.com",
    "user13@o5iv6l.com",
    "user14@dh5yk7.com",
    "user15@91q3qj.com",
    "user16@eav77x.com",
    "user17@jghoh4.com",
    "user18@l0fzna.com",
    "user19@x1bs0q.com",
    "user20@eoxcdy.com",
    "user21@b1rzkk.com",
    "user22@7rmwv6.com",
    "user23@o9yusg.com",
    "user24@fdnmcz.com",
    "user25@ntcz90.com",
    "user26@i9y43m.com",
    "user27@f1r8el.com",
    "user28@jpzecp.com",
    "user29@ymz3qy.com",
    "user30@jb4tl4.com",
    "user31@azqd54.com",
    "user32@vjj8bs.com",
    "user33@lntc9n.com",
    "user34@jfj1ik.com",
    "user35@pk8w45.com",
    "user36@jg9pnp.com",
    "user37@u4a45s.com",
    "user38@hyivve.com",
    "user39@9pbjj6.com",
    "user40@f2m1ly.com",
    "user41@ytrsjt.com",
    "user42@qr5wp5.com",
    "user43@5twwdj.com",
    "user44@zst67r.com",
    "user45@2l1tge.com",
    "user46@unvlym.com",
    "user47@wwyyd2.com",
    "user48@ss52m9.com",
    "user49@p0r3r3.com",
    "user50@bnmp0t.com",
    "user51@xc25g5.com",
    "user52@w1km8z.com",
    "user53@26v9n4.com",
    "user54@ie4j7v.com",
    "user55@owx6j5.com",
    "user56@55yn6a.com",
    "user57@2mzea6.com",
    "user58@6dhekp.com",
    "user59@8yzgjy.com",
    "user60@25z1w8.com",
    "user61@7yv4h0.com",
    "user62@lm96to.com",
    "user63@rkk3xq.com",
    "user64@sfdsc2.com"
];
  